import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { OnlineStoreSetupCardComponent } from './online-store-setup-card/online-store-setup-card.component';
import { OnlineStoreSetupComponent } from './online-store-setup.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatButtonModule } from '@angular/material/button';
import { EcommerceService } from '../../core/site/ecommerce.service';
import { SiteEditService } from '../../core/site-edit';
import { AnalyticsModule } from '../analytics/analytics.module';

import { MatExpansionModule } from '@angular/material/expansion';

@NgModule({
  imports: [
    MatCardModule,
    TranslateModule,
    FormsModule,
    MatIconModule,
    MatSlideToggleModule,
    MatProgressSpinnerModule,
    MatButtonModule,
    AnalyticsModule,
    CommonModule,

    MatExpansionModule,
  ],
  declarations: [OnlineStoreSetupCardComponent, OnlineStoreSetupComponent],
  exports: [OnlineStoreSetupComponent],
  providers: [EcommerceService, SiteEditService],
})
export class OnlineStoreSetupModule {}
